"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spaces = exports.GavelConfig = exports.GavelAuthoringConfig = exports.Templates = exports.Configuration = exports.Types = void 0;
/**
 *
 * Gavel's Client Library will be split into several modules.
 *
 * Configuration will cover options discovery and selections, and building configurations.
 *
 * Then there will be modules for each of the resources that are required for configuration:
 *
 * - Spaces
 * - Templates
 * - Rules
 * - Modular Templates
 *
 * Each of these will be split into read and write, and each will expose an Effect
 * service to interact with them.
 */
exports.Types = __importStar(require("./types"));
exports.Configuration = __importStar(require("./configuration"));
exports.Templates = __importStar(require("./templates"));
var gavelConfig_1 = require("./gavelConfig");
Object.defineProperty(exports, "GavelAuthoringConfig", { enumerable: true, get: function () { return gavelConfig_1.GavelAuthoringConfig; } });
Object.defineProperty(exports, "GavelConfig", { enumerable: true, get: function () { return gavelConfig_1.GavelConfig; } });
exports.Spaces = __importStar(require("./spaces"));
